import { type MagentoProduct } from "@jti/magento-types";
import { useQuery } from "@jti/rest-api";

import { magento } from "../../clients/getClient";

export type UseNormalizedProductsDetailsData = {
  items: Record<string, MagentoProduct>;
  keys: string[];
};

export const useProductsDetails = (skus: string[], queryKey: string | undefined = "GET_PRODUCTS_DETAILS_BY_SKU") =>
  useQuery([queryKey, skus], () => magento.getProductsDetailsBySku(skus, skus.length ?? 1), {
    enabled: !!skus.length,
  });

export const useNormalizedProductsDetails = (
  skus: string[],
  queryKey: string | undefined = "GET_NORMALIZED_PRODUCTS_DETAILS_BY_SKU"
) =>
  useQuery<UseNormalizedProductsDetailsData>(
    [queryKey, ...skus],
    async () => {
      const { products } = await magento.CUSTOM_TYPES_BETA__getProductsDetailsBySku(skus, skus.length ?? 1);

      return products.items.reduce<UseNormalizedProductsDetailsData>(
        (accumulator, product) => {
          return {
            items: {
              ...accumulator.items,
              [product.sku]: product,
            },
            keys: [...accumulator.keys, product.sku],
          };
        },
        { items: {}, keys: [] }
      );
    },
    {
      enabled: !!skus.length,
    }
  );
